import { useAppDispatch, useAppSelector } from "app/hooks"
import { clearNoFoodFromBarcode, searchFoodByBarcode } from "../mealSlice"
import { useFailed, useSuccess } from "features/notification/hooks"

const useSearchFoodByBarcode = (callback?: () => void) => {
  const searchFoodByBarcodeLoading = useAppSelector(
    (state) => state.meal.searchFoodByBarcodeLoading,
  )
  const searchFoodByBarcodeFailed = useAppSelector(
    (state) => state.meal.searchFoodByBarcodeFailed,
  )
  const searchFoodByBarcodeResult = useAppSelector(
    (state) => state.meal.searchFoodByBarcodeResult,
  )

  const noFoodFoundFromBarcode = useAppSelector(
    (state) => state.meal.noFoodFoundFromBarcode,
  )

  const dispatch = useAppDispatch()

  const handleSearchFoodByBarcode = (barcode: string) => {
    dispatch(searchFoodByBarcode(barcode))
  }

  useFailed(searchFoodByBarcodeFailed)
  useSuccess(searchFoodByBarcodeResult, { message: "" }, callback)

  const clearNoFoodFromBarcodeState = () => {
    dispatch(clearNoFoodFromBarcode())
  }

  return {
    searchFoodByBarcodeLoading,
    handleSearchFoodByBarcode,
    noFoodFoundFromBarcode,
    clearNoFoodFromBarcodeState,
  }
}

export default useSearchFoodByBarcode
